/*
 * Public API Surface of packaging-reuse
 */

export * from './pages/packaging-reuse.component';
export * from './lib/packaging-reuse.module';
